<template>
  <div :class="['survey']">
    <progress-bar :value="progress"></progress-bar>
    <div
      :id="cssId(config.options)"
      :class="cssClass('survey-component', config.options)"
    >
      <transition name="fade" mode="out-in">
        <component
          :key="config.options.key"
          :is="config.options.type"
          :config="config.options"
        ></component>
      </transition>
    </div>
  </div>
</template>

<script>
import Progress from "./Progress";
import SingleSelect from "./SingleSelect";
import MultiSelect from "./MultiSelect";
import QuizSelect from "./QuizSelect";
import PollSelect from "./PollSelect";
import SliderQuestions from "./SliderQuestions.vue";
import TextContent from "./TextContent";
import UserInfo from "./UserInfo";
import Form from "./Form";
import Velocity from "velocity-animate";

export default {
  name: "SurveyPage",
  props: ["config"],
  components: {
    SingleSelect,
    MultiSelect,
    QuizSelect,
    SliderQuestions,
    PollSelect,
    TextContent,
    UserInfo,
    Form,
    "progress-bar": Progress
  },
  data() {
    return {
      progress: 0
    };
  },
  created() {
    this.updateProgess();
  },
  methods: {
    updateProgess() {
      let keys = this.$store.getters.questionKeys;
      this.progress =
        ((keys.indexOf(this.config.options.key) + 1) / keys.length) * 100;
    },
    appear(el, done) {
      Velocity(
        el,
        { opacity: 0, translateY: "-100%", translateZ: 0 },
        { duration: 0 }
      );
      var delay = 0;
      setTimeout(function() {
        Velocity(
          el,
          { opacity: 1, translateY: "0%", translateZ: 0 },
          { complete: done, duration: 550, delay: delay }
        );
      });
    }
  },
  watch: {
    $route(to, from) {
      this.updateProgess();
    }
  }
};
</script>

<style lang="scss">
@import "../scss/components/survey";
</style>
